import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MonitorTagByUser } from '../../models/view-models/tag-models/tag-by-user.view-model';
import { AppConfig } from '../../../app.settings';

@Injectable()
export class AdministratorMonitorTagService {

    endpoint: string;

    constructor(public http: HttpClient, public config: AppConfig) {
        this.endpoint = this.config.getConfig('api') + 'Admin/monitor-tag-management';
    }

    getMonitorTagsByUsers(): Observable<MonitorTagByUser[]> {
        const url = this.endpoint + '/monitor-tags-by-users';
        return this.http.get<MonitorTagByUser[]>(url, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
    }

    getMonitorTagsByCurrentUser(): Observable<MonitorTagByUser[]> {
      const url = this.endpoint + '/monitor-tags-by-user';
      return this.http.get<MonitorTagByUser[]>(url, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }
}
